<template>
  <div class="space-y-5 pt-2 pb-2">
    <!-- Opción PAdES (Recomendado) -->
    <div 
      class="border-2 p-5 md:p-6 transition-all duration-300 shadow-md cursor-pointer group relative overflow-hidden transform hover:-translate-y-1 hover:shadow-xl"
      style="border-radius: 16px;"
      :class="currentMode === 'PDF_SIGNATURE' ? 'border-primary shadow-lg ring-2 ring-primary/20' : 'bg-white border-gray-200 hover:border-primary'"
      :style="currentMode === 'PDF_SIGNATURE' ? 'background-color: #ede7f6;' : ''"
      @click="selectPades"
    >
      <!-- Decoración de fondo -->
      <div class="absolute top-0 right-0 w-32 h-32 bg-primary-fixed rounded-bl-full -mr-8 -mt-8 opacity-50 transition-transform duration-500 group-hover:scale-125"></div>
      
      <div class="flex items-start justify-between mb-3 relative z-10">
        <div class="flex items-center gap-4">
          <div class="w-12 h-12 rounded-full flex items-center justify-center shrink-0 transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3"
               :class="currentMode === 'PDF_SIGNATURE' ? 'bg-primary text-white' : 'text-primary group-hover:bg-primary group-hover:text-white'"
               :style="currentMode !== 'PDF_SIGNATURE' ? 'background-color: #ede7f6;' : ''">
            <feather-icon icon="FileTextIcon" svgClasses="w-6 h-6 transition-colors" />
          </div>
          <div>
            <div class="flex flex-wrap items-center gap-2 mb-1">
              <h3 class="font-bold text-lg text-gray-800 m-0 transition-colors" :class="currentMode === 'PDF_SIGNATURE' ? 'text-primary' : 'group-hover:text-primary'">Firma Avanzada PAdES (PDF)</h3>
              <span class="bg-primary text-white text-[10px] font-bold px-2 py-0.5 rounded uppercase tracking-wider shadow-sm">Recomendado</span>
            </div>
          </div>
        </div>
        <!-- Texto de Seleccionado en Verde -->
        <div v-if="currentMode === 'PDF_SIGNATURE'" class="flex items-center gap-1.5 text-success font-bold text-sm shrink-0 animate-fade-in mt-1">
          <feather-icon icon="CheckCircleIcon" svgClasses="w-5 h-5 text-success" />
          Seleccionado
        </div>
      </div>
      
      <div class="pl-16 relative z-10">
        <p class="text-[13px] md:text-sm text-gray-600 font-medium leading-relaxed mb-5">
          Convierte el documento original en el estándar PAdES conforme a la especificación ISO-32000-1, agregando campos de firma de los firmantes. 
          <a target="_blank" href="https://ayuda.verificamex.com/article/59-diferencia-entre-estrategia-de-firmado-pades-y-convencional" class="text-primary hover:underline font-bold ml-1 inline-flex items-center" @click.stop>
            Saber más <feather-icon icon="ExternalLinkIcon" svgClasses="w-3 h-3 ml-1" />
          </a>
        </p>

        <div class="flex justify-end">
          <vs-button @click.stop="selectPades" type="filled" color="primary" class="shadow-sm font-bold w-full sm:w-auto transition-transform active:scale-95">
            Seleccionar PAdES
          </vs-button>
        </div>
      </div>
    </div>

    <!-- Opción Clásica (XML) -->
    <div 
      class="border-2 p-5 md:p-6 transition-all duration-300 shadow-md cursor-pointer group relative overflow-hidden transform hover:-translate-y-1 hover:shadow-xl"
      style="border-radius: 16px;"
      :class="currentMode === 'CLASSIC' ? 'border-primary shadow-lg ring-2 ring-primary/20' : 'bg-white border-gray-200 hover:border-primary'"
      :style="currentMode === 'CLASSIC' ? 'background-color: #ede7f6;' : ''"
      @click="submitNewDocument('CLASSIC')"
    >
      <div class="flex items-start justify-between mb-3 relative z-10">
        <div class="flex items-center gap-4">
          <div class="w-12 h-12 rounded-full flex items-center justify-center shrink-0 transition-transform duration-300 group-hover:scale-110 group-hover:-rotate-3"
               :class="currentMode === 'CLASSIC' ? 'bg-primary text-white' : 'bg-gray-100 text-gray-500 group-hover:text-primary'">
            <feather-icon icon="LayersIcon" svgClasses="w-6 h-6 transition-colors" />
          </div>
          <div>
            <h3 class="font-bold text-lg text-gray-800 m-0 transition-colors" :class="currentMode === 'CLASSIC' ? 'text-primary' : 'group-hover:text-primary'">Firma Electrónica Avanzada</h3>
          </div>
        </div>
        <!-- Texto de Seleccionado en Verde -->
        <div v-if="currentMode === 'CLASSIC'" class="flex items-center gap-1.5 text-success font-bold text-sm shrink-0 animate-fade-in mt-1">
          <feather-icon icon="CheckCircleIcon" svgClasses="w-5 h-5 text-success" />
          Seleccionado
        </div>
      </div>
      
      <div class="pl-16 relative z-10">
        <p class="text-[13px] md:text-sm text-gray-600 font-medium leading-relaxed mb-5">
          Conserva el documento original intacto y agrega una hoja adicional de firmas al final del documento.
          <a target="_blank" href="https://ayuda.verificamex.com/article/59-diferencia-entre-estrategia-de-firmado-pades-y-convencional/" class="text-primary hover:underline font-bold ml-1 inline-flex items-center" @click.stop>
            Saber más <feather-icon icon="ExternalLinkIcon" svgClasses="w-3 h-3 ml-1" />
          </a>
        </p>

        <div class="flex justify-end">
          <vs-button @click.stop="submitNewDocument('CLASSIC')" type="border" color="primary" class="font-bold w-full sm:w-auto transition-transform active:scale-95">
            Seleccionar Clásica
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SignSelector",
  props: ['openSignPositionPopup', 'submitNewDocument', 'currentMode', 'setSignPosition'],
  methods: {
    selectPades() {
      if (this.setSignPosition) {
        this.setSignPosition('CUSTOM');
      }
      this.submitNewDocument('PDF_SIGNATURE');
    }
  }
}
</script>

<style scoped>
@keyframes fadeIn {
  from { opacity: 0; transform: scale(0.9); }
  to { opacity: 1; transform: scale(1); }
}
.animate-fade-in {
  animation: fadeIn 0.3s ease-out forwards;
}
</style>
